var React = require('react');

function WindowFrame (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M272,64V224H416V64ZM96,224H240V64H96Zm0,224H240V288H96Zm176,0H416V288H272Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M496,448H480V32A32,32,0,0,0,448,0H64A32,32,0,0,0,32,32V448H16A16,16,0,0,0,0,464v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V464A16,16,0,0,0,496,448Zm-256,0H96V288H240Zm0-224H96V64H240ZM416,448H272V288H416Zm0-224H272V64H416Z","className":"fa-primary","key":2})]);
}

WindowFrame.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WindowFrame;

WindowFrame.default = WindowFrame;
